/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/App/Account/Content/Settings/Content/CommsEmail/Emails/Emails/Content/Email/Email"
  
}) {
let emailEmailValueData = fromData.useDataValue({ viewPath,
context: 'email',
path: 'email',
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="email.email"
 text={emailEmailValueData}
/>
{children}
</React.Fragment>)
}